import styles from './Modal.module.css'

const Modal = ({ name, children, onClickClose }) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_header}>
          {name}
          <div
            className={styles.modal_close}
            onClick={() => onClickClose(false)}
          >
            ×
          </div>
        </div>
        <div className={styles.modal_body}>{children}</div>
      </div>
    </div>
  )
}

export default Modal
